import { MFLink } from '@medifind/shared-basic-components';
import { Skeleton } from '@medifind/shared-basic-components';

const ClinicalTrialSource = ({ isLoading, url }) => {
  return (
    <p style={{ marginLeft: '1rem', marginTop: '1.5rem' }}>
      {!isLoading ? (
        <>
          <span>This content was sourced from </span>
          <MFLink href={url} target="_blank">
            clinicaltrials.gov
          </MFLink>
        </>
      ) : (
        <Skeleton />
      )}
    </p>
  );
};

export { ClinicalTrialSource as default, ClinicalTrialSource };
